import axios from 'axios'

async function delete_job(data,token,dispatch,add_job,add_jobs,jobs,setDeleting,setMessage,setOpen,navigate){

try{

setDeleting(true)

const deleteJob = await axios.post(`${process.env.REACT_APP_SERVER_AUTH_URL}delete-job/`,data,{
        headers:{
            "Content-Type":"application/json",
            "Authorization":`Bear ${token}`
            }
    }).catch(err=>{console.log(err)})

if (deleteJob?.status == 200 && deleteJob?.data.success) {

    const filterJobs = jobs?.filter(item=>item?.id !== data?.id)
    dispatch(add_jobs(filterJobs))
    dispatch(add_job({}))
    setMessage("Job has been deleted successfully")
    setOpen(true)
    navigate("/myJobs")
    
}else{
    setMessage(deleteJob?.data?.message)
    setOpen(true)
}
setDeleting(false)
}catch(err){
    console.log(err)
}
}

export default delete_job